import { Container, Row } from "reactstrap";
import { GroupButtonClass } from "./GroupButtonClass";
import { RadioCheckboxButton } from "./RadioCheckboxButton/RadioCheckboxButton";
import { NestingButton } from "./NestingButton/NestingButton";
import { VerticalButtonGroup } from "./VerticalButtonGroup";
import { Breadcrumbs } from "../../../AbstractElements";
import { ButtonGroupTitle, ButtonsTitle } from "../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";

const ButtonGroupContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs  mainTitle={ButtonGroupTitle} parent={ButtonsTitle}/>
      <Container fluid>
        <Row>
          <GroupButtonClass />
          <RadioCheckboxButton />
          <NestingButton />
          <VerticalButtonGroup />
        </Row>
      </Container>
    </Fragment>
  );
};
export default ButtonGroupContainer;